import { IApplicationState } from '../../types/redux';
import { IGeoRoadInfoSchema } from '../../../shared/repositories/newbuilding-card/entities/geo/GeoRoadInfoSchema';

export function getRoadInfo(state: IApplicationState): IGeoRoadInfoSchema[] | null {
  const {
    newbuilding: { geo },
  } = state;

  if (geo && geo.roadInfo && geo.roadInfo.length) {
    return geo.roadInfo;
  }

  return null;
}
